import { createApp,h } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import 'primevue/resources/themes/lara-light-blue/theme.css'
// vela-blue
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'

import PrimeVue from 'primevue/config'
import AutoComplete from 'primevue/autocomplete';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';     //optional for column grouping
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Divider from 'primevue/divider';
import Image from 'primevue/image';
import Message from 'primevue/message';
import Password from 'primevue/password';
import Panel from 'primevue/panel';
import SelectButton from 'primevue/selectbutton';
import Sidebar from 'primevue/sidebar';
import TabMenu from 'primevue/tabmenu'
import Menu from 'primevue/menu'
import Tag from 'primevue/tag'
import Tooltip from 'primevue/tooltip'
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';

import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import './assets/styles/layout.scss';

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL


axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      store.dispatch('auth/logout')
      return router.push('/login')
    }
    return Promise.reject(error)
  }
})


const user = JSON.parse(localStorage.getItem('user'))
if (user && user.access_token) {
  	axios.defaults.headers.common.Authorization = 'Bearer ' + user.access_token
}

const app = createApp(App)
//const app = createApp({
//  methods: {
//    isDesktop() {
//      return window.innerWidth >= 992;
//    }
//  },
//  render: () => h(App)
//})

app.use(store)
app.use(router)


app.use(PrimeVue, {ripple: true})
app.use(ToastService)
app.use(ConfirmationService);

app.component('AutoComplete', AutoComplete)
app.component('InputText', InputText)
app.component('Button', Button)
app.component('Breadcrumb', Breadcrumb)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('ColumnGroup', ColumnGroup)
app.component('Card', Card)
app.component('Checkbox', Checkbox)
app.component('Dialog', Dialog)
app.component('Divider', Divider)
app.component('Dropdown', Dropdown)
app.component('Image', Image)
app.component('Message', Message)
app.component('Panel', Panel)
app.component('Password', Password)
app.component('SelectButton', SelectButton)
app.component('Sidebar', Sidebar)
app.component('TabMenu', TabMenu)
app.component('Tag', Tag)
app.component('Menu', Menu)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)

app.directive('tooltip', Tooltip)

app.mount('#app')
